/**
 * Shared “click / touch hit a HUD or chrome control” checks.
 * Keep selectors in one place so pointer + touch stay aligned.
 */

const WEAPON_CYCLE_IGNORE =
  '.arcade-ammo-hud, .arcade-railgun-hud, .arcade-chaff-hud, .arcade-score-hud, .arcade-taskbar, .arcade-start-menu, .arcade-spawn-enemy, .arcade-spawn-enemy-row, .arcade-spawn-teammate-row, .arcade-enemy-count, .arcade-teammate-count, .arcade-spawn-teammate, .arcade-immortal, .arcade-stop-obstacles, .arcade-obstacle-limit, .arcade-settings-btn, .arcade-hud-icon-btn, .arcade-hud-icon-row, .arcade-hud-top-right, .settings-window-frame, .nav, [class*="window"], .os-window';

const TOUCH_PLAY_IGNORE =
  '.arcade-spawn-enemy, .arcade-spawn-enemy-row, .arcade-spawn-teammate-row, .arcade-enemy-count, .arcade-teammate-count, .arcade-spawn-teammate, .arcade-immortal, .arcade-stop-obstacles, .arcade-obstacle-limit, .arcade-settings-btn, .arcade-hud-icon-btn, .arcade-hud-icon-row, .os-window';

const TOUCH_END_UI =
  '.arcade-ammo-hud, .arcade-railgun-hud, .arcade-chaff-hud, .arcade-spawn-enemy, .arcade-spawn-enemy-row, .arcade-spawn-teammate-row, .arcade-enemy-count, .arcade-teammate-count, .arcade-spawn-teammate, .arcade-immortal, .arcade-stop-obstacles, .arcade-obstacle-limit';

const DESKTOP_START_IGNORE =
  '.desktop-icon, .arcade-taskbar, .arcade-start-menu, [class*="window"], .nav';

export function isWeaponCycleIgnoredTarget(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest(WEAPON_CYCLE_IGNORE));
}

export function isTouchPlayIgnoredTarget(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest(TOUCH_PLAY_IGNORE));
}

export function isTouchEndUiTarget(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest(TOUCH_END_UI));
}

export function isDesktopStartIgnoredTarget(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest(DESKTOP_START_IGNORE));
}

export function isAmmoHudTarget(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest('.arcade-ammo-hud'));
}

export function isRailgunHudTarget(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest('.arcade-railgun-hud'));
}

export function isChaffHudTarget(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest('.arcade-chaff-hud'));
}
